import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, checkboxField} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import {USER_CONFIGS_UPDATED, sendUserConfigs, queryUserConfigs} from '../actions'
import {UserConfigs} from '../models'
import i18n from '../i18n'

class UserConfigsModal extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, user} = this.props
        dispatch(queryUserConfigs(user.uid))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user != this.props.user
            || (nextProps.show && nextProps.show != this.props.show)) {
            const {dispatch, user} = nextProps
            dispatch(queryUserConfigs(user.uid))
        }
    }

    _sendCmd() {
        const {dispatch, user, onHide} = this.props

        return dispatch(sendUserConfigs(user.uid)).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, user, userConfigs, onHide, ...others} = this.props

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.configs}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        {userConfigs.ticketOpenedNotifications !== undefined && (
                            <Input
                                type='checkbox'
                                name='ticketOpenedNotifications'
                                label={i18n.ticketOpenedNotifications}
                                {...checkboxField(form.ticketOpenedNotifications())} />
                        )}
                        {userConfigs.daybookNotifications !== undefined && (
                            <Input
                                type='checkbox'
                                name='daybookNotifications'
                                label={i18n.daybookNotifications}
                                {...checkboxField(form.daybookNotifications())} />
                        )}
                        {userConfigs.simplifiedRequestOpenedNotifications !== undefined && (
                            <Input
                                type='checkbox'
                                name='simplifiedRequestOpenedNotifications'
                                label={i18n.simplifiedRequestOpenedNotifications}
                                {...checkboxField(form.simplifiedRequestOpenedNotifications())} />
                        )}
                    </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

UserConfigsModal = connectForm({
    target: 'userConfigs',
    schema: UserConfigs.schema,
    action: USER_CONFIGS_UPDATED
})(UserConfigsModal)

UserConfigsModal = connect((state) => ({
    userConfigs: state.company.user.userConfigs
}))(UserConfigsModal)

export default UserConfigsModal


// WEBPACK FOOTER //
// ./lib/company/components/UserConfigsModal.js